import React from 'react'

import { useConnect } from 'redux-bundler-hook'

import { Typography } from '@mui/material'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import Tooltip from '~/src/UI/Shared/Tooltip'
import { buildThemeFromColor } from '~/src/UI/Theme/mui'
import WhereWidget from '~/src/UI/Widgets/Where'

const defaultTitleProps = { color: 'textPrimary', variant: 'body1' }

export const AEJournalLocationCell = props => {
  const { classes, data, location, titleProps = defaultTitleProps } = props
  const { colorsByKey } = useConnect('selectColorsByKey')

  let locationTitle = 'No location'
  if (location) {
    if (typeof location === 'string') {
      locationTitle = location
    } else {
      const roomList = Object.entries(location)
      locationTitle = (
        <Tooltip
          arrow
          interactive
          variant="dark"
          title={(
            <>
              {roomList.map(([prefix, name]) => (
                <StyledEngineProvider injectFirst>
                  <ThemeProvider
                    key={`${name}_${prefix}`}
                    theme={theme => buildThemeFromColor(
                      colorsByKey[prefix.toUpperCase()]
                        ?? { main: theme.palette.gray }
                    )}
                  >
                    <p style={{ display: 'flex', minWidth: '10rem' }}>
                      <Typography color="primary" component="span" style={{ minWidth: '4rem' }}>
                        {prefix}:&nbsp;
                      </Typography>
                      <Typography component="span" color="primary">
                        {name}
                      </Typography>
                    </p>
                  </ThemeProvider>
                </StyledEngineProvider>
              ))}
            </>
          )}
        >
          <Typography {...defaultTitleProps}>{roomList.length} rooms</Typography>
        </Tooltip>
      )
    }
  }

  return (
    <WhereWidget
      title={locationTitle}
      room={data.room}
      zone={data.zone}
      classes={{ root: classes.locationText }}
      titleProps={React.isValidElement(locationTitle) && !data?.room ? undefined : titleProps}
    />
  )
}

export default React.memo(AEJournalLocationCell)
